module.exports = __webpack_public_path__ + "img/question-mark.5acba150.svg";